import UIControllerView from './ui-controller-view.js';

export default UIControllerView;
